import { toast, ToastContent, ToastOptions } from 'react-toastify';
import { getVerboseActive } from './verbose';

export function showToast(message: ToastContent, options?: ToastOptions): void {
  if (getVerboseActive()) {
    toast.info(message, options);
  }
}
export function showNativeCallToast(payload): void {
  if (!getVerboseActive()) {
    return;
  }
  const nativeValues = getNativeValues(payload);
  const tempValues = nativeValues.length > 0 ? `${nativeValues.join('\n')}` : '';
  const message = `${payload.methodName}\n${tempValues}`;
  showToast(message, { autoClose: false });
}

function getNativeValues(payload): string[] {
  return Object.keys(payload)
    .filter((key) => key !== 'methodName')
    .sort()
    .map((key) => `${key}: ${JSON.stringify(payload[key], null, 2)}`);
}
